import { HTTPClient } from "@abaco/web-common/src/HTTP";
import { SfeComparison, SfeGrapeVariety } from "../models/SfeProd";

export default class SfeProdApi {

    private http: HTTPClient;
    private rootApi!: string;

    constructor(http: HTTPClient, rootApi: string) {
        this.http = http;
        this.rootApi = rootApi;
    }

    public async getSfeProd(pkCuaa: number, campaign: number, lot_id: number | null, seed_variety_id: number | null ): Promise<SfeGrapeVariety[]> {

        let params  = {};

        if(lot_id !== undefined && lot_id !== null){
            params = {
                ...params,
                lot_id: lot_id
            }
        }

        if(seed_variety_id !== undefined && seed_variety_id !== null){
            params = {
                ...params,
                seed_variety_id: seed_variety_id
            }
        }
        const res = await this.http.get(`${this.rootApi}/v1/a4grapes/subjects/${pkCuaa}/${campaign}/sfeprod/variety`, {
            params: params
        });
        return res.data;
    }


    public async getSfeProdForCompare(pkCuaa: number, campaign: number, lot_id: number | null, seed_variety_id: number | null ): Promise<SfeComparison[]> {
        let params  = {};
        if(lot_id !== undefined && lot_id !== null){
            params = {
                ...params,
                lot_id: lot_id
            }
        }
        if(seed_variety_id !== undefined && seed_variety_id !== null){
            params = {
                ...params,
                seed_variety_id: seed_variety_id
            }
        }
        const res = await this.http.get(`${this.rootApi}/v1/a4grapes/subjects/${pkCuaa}/${campaign}/sfeprod`, {
            params: params
        });
        return res.data;
    }



}
